// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oF_aFDYZQNezMtDpE3_e {


} 

.oF_aFDYZQNezMtDpE3_e select {
  outline: none;
  border: none;
  border-radius: 5px;
  width: 150px;
  padding: 5px 10px
}

.GJXXdxs2I6Eq4Rh7DWAn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 15px 0;
}
.GJXXdxs2I6Eq4Rh7DWAn img {
  max-width: 120px;
}

.pBfh3gIKTY6e9SwTAZ1F {
}

.Ec_TurR3NTfA3OYDlgfh {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 5px;
}

.Ec_TurR3NTfA3OYDlgfh input {
  outline: none;
  border: none;
  border-radius: 5px;
  width: 70px;
  padding: 5px 10px
}

.uFzQRoJbXyEVJTKU8twn {
  display: flex;
  justify-content: center;
  max-width: 300px;
  gap: 15px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/Views/StatEditor/index.module.css"],"names":[],"mappings":"AAAA;;;AAGA;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB","sourcesContent":[".statEditor {\n\n\n} \n\n.statEditor select {\n  outline: none;\n  border: none;\n  border-radius: 5px;\n  width: 150px;\n  padding: 5px 10px\n}\n\n.statInputsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin: 15px 0;\n}\n.statInputsContainer img {\n  max-width: 120px;\n}\n\n.statInputs {\n}\n\n.inputGroup {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  margin-bottom: 5px;\n}\n\n.inputGroup input {\n  outline: none;\n  border: none;\n  border-radius: 5px;\n  width: 70px;\n  padding: 5px 10px\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  max-width: 300px;\n  gap: 15px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statEditor": `oF_aFDYZQNezMtDpE3_e`,
	"statInputsContainer": `GJXXdxs2I6Eq4Rh7DWAn`,
	"statInputs": `pBfh3gIKTY6e9SwTAZ1F`,
	"inputGroup": `Ec_TurR3NTfA3OYDlgfh`,
	"buttons": `uFzQRoJbXyEVJTKU8twn`
};
export default ___CSS_LOADER_EXPORT___;
